import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  PageHeader,
  Button,
  Divider,
  Table,
  Form,
  Select,
  Input,
  Descriptions,
  message,
  Image,
} from "antd";
import { FlexRowReverseContainer } from "../../Common/Container.styles";
import { Option } from "antd/lib/mentions";

import * as userAPI from "../../../api/user";
import { dateToString } from "../../../util/common";

function UserDetail() {
  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const fetchUser = () => {
    userAPI
      .getUser({ id: params.id })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setUser(res.data.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const columns = [
    {
      title: "추천 정보 내용",
      dataIndex: "content",
      render: (val) => {
        return val ?? "-";
      },
    },
  ];

  const [displayTargetValue, setDisplayTargetValue] = useState(null);
  const [targetName, setTargetName] = useState(null);

  return (
    <div>
      <PageHeader className="site-page-header" title="회원 조회" />
      <FlexRowReverseContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            navigate(`/user/info`);
          }}
          style={{ margin: "0 10px" }}
        >
          목록
        </Button>
      </FlexRowReverseContainer>
      <Divider />
      {/* 글번호, 공지제목, 작성자명, 등록년월일시, 최정수정년월일시, 글내용*/}
      {loading && <></>}
      {!loading && (
        <>
          <Descriptions
            labelStyle={{ fontWeight: 800, marginBottom: "30px" }}
            bordered
          >
            <Descriptions.Item label="회원번호" span={1}>
              {user.id ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="닉네임" span={1}>
              {user?.headProfile?.nickname ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="성별" span={1}>
              {user?.headProfile?.gender ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="이메일" span={1}>
              <div>
                {"email" === targetName && displayTargetValue
                  ? displayTargetValue
                  : user.email ?? "-"}
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="연락처" span={2}>
              <div>
                {"phone" === targetName && displayTargetValue
                  ? displayTargetValue
                  : user?.phone ?? "-"}
              </div>
            </Descriptions.Item>
            <Descriptions.Item
              label={user?.userWithdrawalReason ? "탈퇴일시" : "가입일시"}
              span={1}
            >
              {dateToString(
                user?.userWithdrawalReason
                  ? user?.userWithdrawalReason[0]?.createdDate
                  : user?.createdDate
              )}
            </Descriptions.Item>
            <Descriptions.Item label="최종로그인일시" span={2}>
              {dateToString(user?.last_login)}
            </Descriptions.Item>
            <Descriptions.Item label="마케팅동의여부" span={1}>
              {user.agreeMarketing ? "X" : "O"}
            </Descriptions.Item>
            <Descriptions.Item label="소셜로그인타입" span={1}>
              {user?.snsType ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="플랫폼" span={1}>
              {user?.platform ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="생년월일" span={1}>
              {user?.headProfile?.birthday ?? "-"}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
    </div>
  );
}

export default UserDetail;
